import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

interface PageContainerProps {
  children: ReactNode;
  className?: string;
}

export function PageContainer({ children, className }: PageContainerProps) {
  return (
    <div className={cn('min-h-screen bg-background-primary px-4 py-6', className)}>
      <div className="max-w-md mx-auto">
        {children}
      </div>
    </div>
  );
}
